import {inject, observer} from 'mobx-react';
// import {smartJump, getQueryString} from 'utils/utils';

import './index.scss';

@inject(({store}) => ({
    ymbj: store.ymbj,
    isOppo: store.isOppo
}))
@observer class TopActivity extends React.Component {
    openActiocity() {
    }

    render() {
        const {ymbj = {}, isOppo} = this.props;
        let {hbgf = {}, ophbgf = {}} = ymbj;
        if(isOppo) {
            hbgf = ophbgf;
        }
        if (!hbgf.bg || hbgf.switch !== 1) {
            return null;
        }

        return(
            <div className="m-hbgf">
                <img src={hbgf.bg} onClick={()=> {

                }} />
            </div>
        );
    }
}

export default TopActivity;